/**
 * Indonesian copy.
 *
 * Two kinds of string live here, and they never mix:
 * - `copy`: strings this app owns.
 * - `elementPlus`: strings the Element Plus library ships that this app
 *   re-words. The path is relative to the library locale's `el` root.
 *
 * Server-driven copy (footer, headline, login popup, site name) is NOT here.
 * That text arrives from `server-info` and is data, not a locale key.
 */
export const COPY = {
  app: {
    loading: 'Memuat...',
    serverError:
      'Terjadi kesalahan, silahkan muat ulang halaman beberapa saat lagi',
  },
  accountForm: {
    retry: 'Coba lagi',
    loadError: 'Gagal memuat form akun',
    targetWarning:
      'Pastikan nomor tujuan benar. Transaksi tidak dapat dibatalkan setelah pembayaran.',
    accountWarning:
      'Pastikan data akun ditulis dengan benar. Transaksi tidak dapat dibatalkan setelah pembayaran.',
    serverNoMatch: 'Server tidak ditemukan',
  },
}

export const ELEMENT_PLUS_COPY = {
  select: {
    noMatch: 'Tidak ada data yang cocok',
  },
}
